import { NuvoModal, NuvoModalProps } from '@nuvolo/nuux-core/components/NuvoModal';
import React from 'react';
import { createPortal } from 'react-dom';

export type ModalProps = NuvoModalProps;

// in some cases the model does not show when rendered inside the app
// so we create a div element globally in the RootPage.tsx and use it here
// then use the div element as a container to put the modal inside it
const Modal: React.FC<ModalProps> = (props) => {
  const portal = document.getElementById('tmm-modal');
  if (!portal) return <></>;

  return createPortal(<NuvoModal {...props} />, portal);
};

export default React.memo(Modal);
